import React, { useEffect, useState, useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Grid from "@mui/material/Grid";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import { withTranslation } from "react-i18next";
import classes from "../dashboard/dashboard.module.css";
import RenderCountPortlet from "./renderCountPortlet";
import RenderGraphPortlet from "./renderGraphPortlet";
import Loader from "../../../../component/loader";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import { Tabs, Tab, radioClasses } from "@mui/material";
import GenericReports from "../../genericReports/reports";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import { useTranslation } from "react-i18next";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {
  SearchIcon,
  ClearIcon,
  DownIcon,
} from "../../../../component/icons/icons";
import moment from "moment";
import GenericTable from "./genericTable";
import Input from "../../../../component/inputpm";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Button from "../../../../component/button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
// import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import Breadcrumb from "../../../../component/breadcrumb";
import { alpha } from "@mui/material/styles";
import Skeleton from 'react-loading-skeleton'
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import Box from "@mui/material/Box";
import { formatDate, convertDateParam, convertTillDateParam } from "../../../../helper/dateFormatter";

import 'react-loading-skeleton/dist/skeleton.css'
// import { withStyles, makeStyles } from '@mui/styles';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     display: 'flex',
//   },
//   filterButtons: {
//     backgroundColor: 'transparent',
//     transition: 'background-color 0.2s ease',
//     '&:hover': {
//       backgroundColor: (props) => props.themeColor ? alpha(props.themeColor, 0.12) : 'transparent',
//       color: (props) => props.themeColor || 'inherit',
//     },
//   },
//   selectedFilterButtons: {
//     backgroundColor: (props) => props.themeColor || 'transparent',
//     color: '#fff',
//     '&:hover': {
//       backgroundColor: (props) => props.themeColor || 'transparent', // keep solid when selected
//     },
//   },
// }));

const DashboardReports = (props) => {
  const { t } = useTranslation();
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [duration, setDuration] = React.useState("year");
  const [genericReportsList, setGenericReportsList] = useState([]);
  const [currentTab, setCurrentTab] = useState(0);
  const [renderGenericReports, setRenderGenericReports] = useState(false);
  const [genericReportParams, setGenericReportParams] = useState({});
  const [reportId, setReportId] = useState(null);
  const [customFromDate, setCustomFromDate] = useState("");
  const [customToDate, setCustomToDate] = useState("");
  const [today, setToday] = useState(moment(new Date()).format("yyyy-MM-DD"));
  const [summaryData, setSummaryData] = useState(null);
  const [summaryDataProxy, setSummaryDataProxy] = useState(null);
  const [summaryTab, setSummaryTab] = useState(0);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // toggle view
  const [dateViewMode, setDateViewMode] = useState("calendar");

  // month/year dropdown state
  const [fromMonth, setFromMonth] = useState("");
  const [fromYear, setFromYear] = useState("");
  const [toMonth, setToMonth] = useState("");
  const [toYear, setToYear] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const id = open ? "simple-popper" : undefined;

  const [showGraphs, setShowGraphs] = useState(true);
  const [showCount, setShowCount] = useState(true);
  const [showSummary, setShowSummary] = useState(true);

  const [opCoList, setOpCoList] = useState([]);
  const [opCo, setOpCo] = useState("ALL");
  const [portletData, setPortletData] = useState({});
  const [fromError, setFromError] = useState(""); // error message string ('' = no error)
  const [toError, setToError] = useState("");
  const [portletLoading, setPortletLoading] = useState({});

  const roles = JSON.parse(localStorage.getItem('roles') || '{}');

  var BILLING_END_DAY =
    roles?.data?.defaultBillingDay
      ? Number(roles.data.defaultBillingDay)
      : 24; // default
  var BILLING_START_DAY = BILLING_END_DAY === 1 ? 1 : BILLING_END_DAY + 1;

  if (props.providerType === "SOLUTION_PROVIDER" || props.tenantRoles.includes("MASTER_PROVIDER")) {
    var opIndex = opCoList.findIndex(x => x.tenantId === opCo);
    if (opIndex > -1) {
      if (opCoList[opIndex].defaultBillingDay) {
        BILLING_END_DAY = opCoList[opIndex].defaultBillingDay;
        BILLING_START_DAY = BILLING_END_DAY + 1;
      }
    }
  }

  const now = moment();

  // cycle start
  let cycleStart = moment().date(BILLING_START_DAY);

  if (now.date() < BILLING_START_DAY) {
    cycleStart.subtract(1, 'month');
  }

  // first bill
  let lastBillDate = moment().date(BILLING_END_DAY);

  if (now.date() <= BILLING_END_DAY) {
    lastBillDate.subtract(1, 'month');
  }

  const firstBillOfYear = moment()
    .year(lastBillDate.year())
    .month(0) // January
    .date(BILLING_END_DAY); // Jan 24

  const yearStart = firstBillOfYear
    .clone()
    .subtract(1, 'month')
    .date(BILLING_START_DAY);

  // Last completed cycle end (24th)
  let lastCycleEnd = moment().date(BILLING_END_DAY);

  if (now.date() <= BILLING_END_DAY) {
    lastCycleEnd.subtract(1, 'month');
  }

  const MIN_DATE_ISO = "2024-01-01";
  const MIN_DATE = new Date(MIN_DATE_ISO);
  const [bread, setBread] = useState([
    { title: t("DASHBOARD"), url: "/dashboard" },
  ]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // handle different roles for dashboard
  const isGroupPM =
    !props.tenantRoles.includes("CHILD_PROVIDER") &&
    props.securityGroupsList.includes("PRODUCT_MANAGER") &&
    !props.securityGroupsList.includes("PARTNER_ADMIN") &&
    props.providerType !== "SOLUTION_PROVIDER";
  const isSalesRep =
    props.tenantRoles.includes("CHILD_PROVIDER") &&
    props.loggedInUserType === "SALES_REPRESENTATIVE" &&
    props.providerType !== "SOLUTION_PROVIDER";
  const isPartnerAdmin =
    props.providerType === "SOLUTION_PROVIDER" &&
    props.securityGroupsList.includes("PARTNER_ADMIN");
  const isSalesManager =
    props.tenantRoles.includes("CHILD_PROVIDER") &&
    props.loggedInUserType === "SALES_MANAGER" &&
    props.providerType !== "SOLUTION_PROVIDER";
  const isFinanceManager =
    !props.tenantRoles.includes("CHILD_PROVIDER") &&
    props.securityGroupsList.includes("FINANCE_MANAGER") &&
    props.providerType !== "SOLUTION_PROVIDER";
  const showSelectOpCo =
    (!props.tenantRoles.includes("CHILD_PROVIDER") &&
      props.providerType !== "SOLUTION_PROVIDER") ||
    props.providerType === "SOLUTION_PROVIDER";

  let summaryTabs = [];
  if (isGroupPM) {
    summaryTabs = [
      { label: t("OP_CO"), value: 0 },
      { label: t("PARTNERS"), value: 1 },
      { label: t("PACKAGES"), value: 2 },
    ];
  } else if (isSalesManager) {
    summaryTabs = [
      { label: t("KAM"), value: 0 },
      { label: t("SECTORS"), value: 1 },
    ];
  } else if (isFinanceManager) {
    summaryTabs = [
      { label: t("OP_CO"), value: 0 },
      { label: t("PARTNERS"), value: 1 },
      { label: t("PACKAGES"), value: 2 },
    ];
  } else if (isPartnerAdmin) {
    summaryTabs = [];
  } else if (isSalesRep) {
    summaryTabs = [];
  }

  useEffect(() => {

    if (dateViewMode !== "monthYear") return;

    if (customFromDate) {

      const from = parseLocalDate(customFromDate);

      setFromMonth(from.getMonth() + 1);
      setFromYear(from.getFullYear());
    }

    if (customToDate) {

      const to = parseLocalDate(customToDate);

      setToMonth(to.getMonth() + 1);
      setToYear(to.getFullYear());
    }

  }, [dateViewMode, customFromDate, customToDate]);

  const handleOpCoChange = (event) => {
    setOpCo(event.target.value);
  };

  const handleChange = (event) => {
    setDuration(event.target.value);
  };

  const handleTabChange = (event, newValue) => {
    // setRenderGenericReports(false);
    var report = genericReportsList[newValue];
    var paramData = {
      state: {
        inputParameters: report.inputParameters ? report.inputParameters : [],
        reportDescription: report.description,
        customFilter: report.customFilter ? report.customFilter : [],
      },
    };
    var reportId = {
      params: {
        reportName: report.name,
      },
    };
    setReportId(reportId);
    setGenericReportParams(paramData);
    setCurrentTab(newValue);
    setRenderGenericReports(true);
  };

  const saveFilterState = () => {
    const filterState = {
      showCount,
      showGraphs,
      showSummary,
      opCo,
      duration,
      customFromDate,
      customToDate,
    };
    localStorage.setItem("dashboardFilters", JSON.stringify(filterState));
  };

  const loadFilterState = () => {
    try {
      const savedState = localStorage.getItem("dashboardFilters");
      if (savedState) {
        const filterState = JSON.parse(savedState);
        setShowCount(filterState.showCount ?? true);
        setShowGraphs(filterState.showGraphs ?? true);
        setShowSummary(filterState.showSummary ?? true);
        setOpCo(filterState.opCo ?? "ALL");
        if (
          filterState.duration === "custom" &&
          (!filterState.customFromDate || !filterState.customToDate)
        ) {
          setDuration("year");
          setCustomFromDate("");
          setCustomToDate("");
        } else {
          setDuration(filterState.duration ?? "year");
          setCustomFromDate(filterState.customFromDate ?? "");
          setCustomToDate(filterState.customToDate ?? "");
        }
      } else {
        console.log("No saved filter state found, using defaults");
      }
    } catch (error) {
      console.error("Error loading filter state:", error);
    }
  };

  const resetFilters = () => {
    setShowCount(true);
    setShowGraphs(true);
    setShowSummary(true);
    setOpCo("ALL");
    setDuration("year");
    setCustomFromDate("");
    setCustomToDate("");
    localStorage.removeItem("dashboardFilters");
  };

  const fetchOpCoList = () => {
    if (showSelectOpCo) {
      BusApiCall(
        "GET",
        `${constants.busInternalUrl}/passthru/GET_OPCO_LIST/endpoint`,
        {},
      ).then((res) => {
        // console.log("opco list ========", res.data);
        setOpCoList(res.data?.tenants || []);
      });
    } else {
      setOpCoList([]);
    }
  };

  useEffect(() => {
    loadFilterState();
    fetchOpCoList();
    fetchData();
    // console.log(
    //   "filter state ========",
    //   localStorage.getItem("dashboardFilters"),
    // );
  }, []);

  useEffect(() => {
    saveFilterState();
  }, [
    showCount,
    showGraphs,
    showSummary,
    opCo,
    duration,
    customFromDate,
    customToDate,
  ]);

  useEffect(() => {
    // fetchOpCoList();
    if (dashboardData && dashboardData.rows) {
      if (
        duration !== "custom" ||
        (duration === "custom" && customFromDate && customToDate)
      ) {
        setPortletData({});
        setPortletLoading({});
        setLoading(true);

        const allPortlets = [];
        dashboardData.rows.forEach((row) => {
          row.columns.forEach((column) => {
            column.portlets.forEach((portlet) => {
              if (portlet.name) {
                allPortlets.push(portlet);
              }
            });
          });
        });

        // const fetchAllPortlets = async () => {
        //   try {
        //     const promises = allPortlets.map((portlet) =>
        //       fetchPortletData(
        //         portlet,
        //         duration,
        //         customFromDate,
        //         customToDate,
        //         opCo,
        //       ),
        //     );

        //     const results = await Promise.allSettled(promises);

        //     const newPortletData = {};
        //     results.forEach((result, index) => {
        //       const portletId = allPortlets[index].id;
        //       if (result.status === "fulfilled") {
        //         newPortletData[portletId] = result.value;
        //       } else {
        //         console.error(
        //           `Error fetching data for portlet ${portletId}:`,
        //           result.reason,
        //         );
        //         newPortletData[portletId] = null;
        //       }
        //     });

        //     setPortletData(newPortletData);
        //   } catch (error) {
        //     console.error("Error fetching portlet data:", error);
        //   } finally {
        //     setLoading(false);
        //   }
        // };
        const fetchAllPortlets = async () => {
          try {
            const promises = allPortlets.map(async (portlet) => {
              const id = portlet.id;
              setPortletLoading(prev => ({ ...prev, [id]: true }));
              try {
                const data = await fetchPortletData(portlet, duration, customFromDate, customToDate, opCo);
                setPortletData(prev => ({ ...prev, [id]: data }));
              } catch (error) {
                console.error(`Error fetching data for portlet ${id}:`, error);
                setPortletData(prev => ({ ...prev, [id]: null }));
              } finally {
                setPortletLoading(prev => ({ ...prev, [id]: false }));
              }
            });

            await Promise.allSettled(promises);
          } catch (error) {
            console.error('Error fetching all portlets:', error);
          } finally {
            setLoading(false);
          }
        };

        fetchAllPortlets();
        fetchSummaryData();
      } else {
        // props.setErrorMessage(t('SELECT_DATE_RANGE'), false);
      }
    }
    // }, [dashboardData, duration, customFromDate, customToDate]);
  }, [dashboardData, duration, opCo]);

  useEffect(() => {
    var reportsList = [];
    for (var i = 0; i < props.genericReports.length; i++) {
      if (
        props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
        props.loggedInUserType === "ECOMMERCE_ADMIN"
      ) {
        if (
          props.genericReports[i].name === "getItemsShippedToCustomer" ||
          props.genericReports[i].name === "getInventoryReceiptReport"
        ) {
          reportsList.push(props.genericReports[i]);
        }
      } else {
        if (
          props.genericReports[i].name === "getSolutionProviderSettlements" ||
          props.genericReports[i].name === "getMonthlyIFRSReport"
        ) {
        } else {
          reportsList.push(props.genericReports[i]);
        }
      }
    }
    setGenericReportsList(reportsList);
    // handleTabChange(null, 0);
  }, [duration, opCo]);

  useEffect(() => {
    if (summaryTabs.length > 0) {
      fetchSummaryData();
    }
  }, [summaryTab]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await BusApiCall(
        "GET",
        `${constants.busInternalUrl}/passthru/GET_DASHBOARD_PORTLET/endpoint`,
        {},
      );
      setDashboardData(res.data);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getBillingRangeForApi = (duration = 'month') => {
    const roles = JSON.parse(localStorage.getItem('roles') || '{}');

    // 🔹 Billing day (bill generated on this day)
    var BILLING_END_DAY = Number(roles?.data?.defaultBillingDay);

    if (!BILLING_END_DAY || BILLING_END_DAY < 1 || BILLING_END_DAY > 31) {
      BILLING_END_DAY = 24;
    }

    // 🔹 Cycle start day (next day)
    var BILLING_START_DAY = BILLING_END_DAY + 1;

    if (props.providerType === "SOLUTION_PROVIDER" || props.tenantRoles.includes("MASTER_PROVIDER")) {
      var opIndex = opCoList.findIndex(x => x.tenantId === opCo);
      if (opIndex > -1) {

        if (opCoList[opIndex].defaultBillingDay) {
          BILLING_END_DAY = opCoList[opIndex].defaultBillingDay;
          BILLING_START_DAY = BILLING_END_DAY + 1;
        }
      }
    }

    const now = moment();

    // ========================
    // Latest COMPLETED bill date
    // ========================
    let lastBillDate = moment().date(BILLING_END_DAY);

    if (now.date() <= BILLING_END_DAY) {
      lastBillDate.subtract(1, 'month');
    }

    // ========================
    // Helper → safe start date
    // ========================
    const createStartDate = (year, month) => {
      const daysInMonth = moment({ year, month }).daysInMonth();

      // Clamp start day to valid day in month
      const safeDay = Math.min(BILLING_START_DAY, daysInMonth);

      return moment({ year, month, date: safeDay });
    };

    let startDate;

    // ========================
    // MONTH → last completed cycle
    // ========================
    if (duration === 'month') {
      const base = lastBillDate.clone().subtract(1, 'month');

      startDate = createStartDate(base.year(), base.month());
    }

    // ========================
    // QUARTERLY → last 3 cycles
    // ========================
    else if (duration === 'quarterly') {
      const base = lastBillDate.clone().subtract(3, 'months');

      startDate = createStartDate(base.year(), base.month());
    }

    // ========================
    // YEAR → from first bill of year
    // ========================
    else if (duration === 'year') {
      const firstBillOfYear = moment()
        .year(lastBillDate.year())
        .month(0) // January
        .date(BILLING_END_DAY);

      const base = firstBillOfYear.clone().subtract(1, 'month');

      startDate = createStartDate(base.year(), base.month());
    }

    // ========================
    // API timestamps (UTC)
    // ========================
    const fromDate = startDate
      .clone()
      .add('day', 1)
      .startOf('day')
      .utc()
      .format('YYYY-MM-DD[T]00:00:00:000[+00:00]');

    const toDate = lastBillDate
      .clone()
      .endOf('day')
      .utc()
      .format('YYYY-MM-DD[T]23:59:59:999[+00:00]');

    return {
      fromDate,
      toDate,
      startDate,
      endDate: lastBillDate,
    };
  };

  const fetchPortletData = async (
    portlet,
    duration,
    customFromDate,
    customToDate,
    opCo,
  ) => {
    const portletId = portlet.id;

    try {
      let url = "";
      // const convertDateParam = (date) => {
      //   return moment(date).format("yyyy-MM-DDTHH:mm:ss:SSS+00:00");
      // };
      // const convertTillDateParam = (date) => {
      //   return moment(date).format("yyyy-MM-DDT23:59:59:999+00:00");
      // };

      if (portlet.type === "count") {
        // Parameters for count portlets
        const leadSector = "";
        const leadKeyAccountManager = "";
        const customerKeyAccountManager = "";
        const assocTenantId = "";
        const salesRepUserId = "";
        const salesRepUserIdForTermination = "";
        const salesProviderId = "";
        const salesProviderIdForAcc = "";
        const tenantIdForTermination = "";
        const partnerId = "";

        if (duration === "custom") {
          if (dateViewMode === "monthYear") {
            var result = adjustMonthRange(customFromDate, customToDate);
            var newCustomFromDate = result.from;
            var newCustomToDate = result.to;
          } else {
            var newCustomFromDate = customFromDate;
            var newCustomToDate = customToDate;
          }

          let fromDate = customFromDate ? encodeURIComponent(convertDateParam(newCustomFromDate)) : '';
          let toDate = customToDate ? encodeURIComponent(convertTillDateParam(newCustomToDate)) : '';
          url = `${constants.busInternalUrl}/graphs/${portlet.id}/records?fromDate=${fromDate}&toDate=${toDate}&leadSector=${leadSector}&leadKeyAccountManager=${leadKeyAccountManager}&customerKeyAccountManager=${customerKeyAccountManager}&assocTenantId=${assocTenantId}&salesRepUserId=${salesRepUserId}&salesRepUserIdForTermination=${salesRepUserIdForTermination}&salesProviderId=${salesProviderId}&salesProviderIdForAcc=${salesProviderIdForAcc}&tenantIdForTermination=${tenantIdForTermination}&partnerId=${partnerId}&tenantId=${opCo !== "ALL" ? opCo : ""}`;
        } else {
          const { fromDate, toDate } = getBillingRangeForApi(duration);
          if ((props.providerType === "SOLUTION_PROVIDER" || props.tenantRoles.includes("MASTER_PROVIDER")) && opCo === 'ALL') {
            url = `${constants.busInternalUrl}/graphs/${portlet.id}/records?duration=${duration}&leadSector=${leadSector}&leadKeyAccountManager=${leadKeyAccountManager}&customerKeyAccountManager=${customerKeyAccountManager}&assocTenantId=${assocTenantId}&salesRepUserId=${salesRepUserId}&salesRepUserIdForTermination=${salesRepUserIdForTermination}&salesProviderId=${salesProviderId}&salesProviderIdForAcc=${salesProviderIdForAcc}&tenantIdForTermination=${tenantIdForTermination}&partnerId=${partnerId}&tenantId=${opCo !== "ALL" ? opCo : ""}`;
          } else {
            url = `${constants.busInternalUrl}/graphs/${portlet.id}/records?fromDate=${fromDate}&toDate=${toDate}&leadSector=${leadSector}&leadKeyAccountManager=${leadKeyAccountManager}&customerKeyAccountManager=${customerKeyAccountManager}&assocTenantId=${assocTenantId}&salesRepUserId=${salesRepUserId}&salesRepUserIdForTermination=${salesRepUserIdForTermination}&salesProviderId=${salesProviderId}&salesProviderIdForAcc=${salesProviderIdForAcc}&tenantIdForTermination=${tenantIdForTermination}&partnerId=${partnerId}&tenantId=${opCo !== "ALL" ? opCo : ""}`;
          }
        }
      } else {
        // Parameters for graph portlets
        const shipmentType = "";
        const quoteType = "";
        const typeId = "";
        const statusType = "";
        const quoteTypeId = "";
        const partnerId = "";

        if (duration === "custom") {
          if (dateViewMode === "monthYear") {
            var result = adjustMonthRange(customFromDate, customToDate);
            var newCustomFromDate = result.from;
            var newCustomToDate = result.to;
          } else {
            var newCustomFromDate = customFromDate;
            var newCustomToDate = customToDate;
          }

          let fromDate = customFromDate ? encodeURIComponent(convertDateParam(newCustomFromDate)) : '';
          let toDate = customToDate ? encodeURIComponent(convertTillDateParam(newCustomToDate)) : '';
          url = `${constants.busInternalUrl}/graphs/${portlet.id}/records?fromDate=${fromDate}&toDate=${toDate}&typeId=${shipmentType}${quoteType}${typeId}&statusId=${statusType}&quoteTypeId=${quoteTypeId}&partnerId=${partnerId}&tenantId=${opCo !== "ALL" ? opCo : ""}`;
        } else {
          const { fromDate, toDate } = getBillingRangeForApi(duration);
          if ((props.providerType === "SOLUTION_PROVIDER" || props.tenantRoles.includes("MASTER_PROVIDER")) && opCo === 'ALL') {
            url = `${constants.busInternalUrl}/graphs/${portlet.id}/records?duration=${duration}&typeId=${shipmentType}${quoteType}${typeId}&statusId=${statusType}&quoteTypeId=${quoteTypeId}&partnerId=${partnerId}&tenantId=${opCo !== "ALL" ? opCo : ""}`;
          } else {
            url = `${constants.busInternalUrl}/graphs/${portlet.id}/records?fromDate=${fromDate}&toDate=${toDate}&typeId=${shipmentType}${quoteType}${typeId}&statusId=${statusType}&quoteTypeId=${quoteTypeId}&partnerId=${partnerId}&tenantId=${opCo !== "ALL" ? opCo : ""}`;
          }
        }
      }

      const response = await BusApiCall("GET", url, {});
      return response.data;
    } catch (error) {
      console.error(`Error fetching data for portlet ${portletId}:`, error);
    }
  };

  const fetchSummaryData = async () => {
    setSummaryLoading(true);
    try {
      var data = {
        // duration: duration,
        fromDate: customFromDate,
        toDate: customToDate,
        tenantId: opCo !== "ALL" ? opCo : "", // why do we need it? since this is a 'summary' for all opcos anyway?
      };
      // Format dates properly for custom duration
      if (duration === "custom") {
        if (!(customFromDate && customToDate)) {
          props.setErrorMessage(t("SELECT_DATE_RANGE"), false);
          return;
        }
        const formatDateForAPI = (dateString, isEndDate = false) => {
          const date = new Date(dateString);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          const time = isEndDate ? "23:59:59:999Z" : "00:00:00:000Z";
          return `${year}-${month}-${day}T${time}`;
        };
        if (dateViewMode === "monthYear") {
          var result = adjustMonthRange(customFromDate, customToDate);
          var newCustomFromDate = result.from;
          var newCustomToDate = result.to;
        } else {
          var newCustomFromDate = customFromDate;
          var newCustomToDate = customToDate;
        }

        data.fromDate = formatDateForAPI(newCustomFromDate, false); // 00:00:00:000Z
        data.toDate = formatDateForAPI(newCustomToDate, true);      // 23:59:59:999Z
      } else {
        const { fromDate, toDate } = getBillingRangeForApi(duration);
        if ((props.providerType === "SOLUTION_PROVIDER" || props.tenantRoles.includes("MASTER_PROVIDER")) && opCo === 'ALL') {
          data.duration = duration;
        } else {
          data.fromDate = fromDate;
          data.toDate = toDate;
        }
      }
      if (isGroupPM) {
        if (summaryTab === 0) {
          const res = await BusApiCall(
            "POST",
            `${constants.busInternalUrl}/passthru/OPCO_SUMMARY_GROUP_PM/endpoint`,
            data,
          );
          setSummaryData(res.data);
          setSummaryDataProxy(res.data);
        } else if (summaryTab === 1) {
          const res = await BusApiCall(
            "POST",
            `${constants.busInternalUrl}/passthru/PARTNER_SUMMARY_GROUP_PM/endpoint`,
            data,
          );
          setSummaryData(res.data);
          setSummaryDataProxy(res.data);
        } else if (summaryTab === 2) {
          const res = await BusApiCall(
            "POST",
            `${constants.busInternalUrl}/passthru/PACKAGE_SUMMARY_GROUP_PM/endpoint`,
            data,
          );
          setSummaryData(res.data);
          setSummaryDataProxy(res.data);
        }
      } else if (isFinanceManager) {
        if (summaryTab === 0) {
          const res = await BusApiCall(
            "POST",
            `${constants.busInternalUrl}/passthru/OPCO_SUMMARY_GROUP_FM/endpoint`,
            data,
          );
          setSummaryData(res.data);
          setSummaryDataProxy(res.data);
        } else if (summaryTab === 1) {
          const res = await BusApiCall(
            "POST",
            `${constants.busInternalUrl}/passthru/PARTNER_SUMMARY_GROUP_FM/endpoint`,
            data,
          );
          setSummaryData(res.data);
          setSummaryDataProxy(res.data);
        } else if (summaryTab === 2) {
          const res = await BusApiCall(
            "POST",
            `${constants.busInternalUrl}/passthru/PACKAGE_SUMMARY_GROUP_FM/endpoint`,
            data,
          );
          setSummaryData(res.data);
          setSummaryDataProxy(res.data);
        }
      } else if (isSalesManager) {
        if (summaryTab === 0) {
          const res = await BusApiCall(
            "POST",
            `${constants.busInternalUrl}/passthru/OPCO_SUMMARY_SALES_MANAGER/endpoint`,
            data,
          );
          setSummaryData(res.data);
          setSummaryDataProxy(res.data);
        } else if (summaryTab === 1) {
          const res = await BusApiCall(
            "POST",
            `${constants.busInternalUrl}/passthru/OPCO_SUMMARY_SALES_MANAGER_SECTORS/endpoint`,
            data,
          );
          setSummaryData(res.data);
          setSummaryDataProxy(res.data);
        }
      } else if (isPartnerAdmin) {
        const res = await BusApiCall(
          "POST",
          `${constants.busInternalUrl}/passthru/OPCO_SUMMARY_PARTNER_ADMIN/endpoint`,
          data,
        );
        setSummaryData(res.data);
        setSummaryDataProxy(res.data);
      }
    } catch (error) {
      console.error("Error fetching summary data:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        props.setErrorMessage(error.response.data.message, false);
      } else {
        props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
      }
      setSummaryData(null);
      setSummaryDataProxy(null);
      setSummaryLoading(false);
    } finally {
      setSummaryLoading(false);
    }
  };

  const adjustMonthRange = (fromDateStr, toDateStr) => {

    const from = new Date(fromDateStr);
    const to = new Date(toDateStr);

    // Set first date to 1st day of month
    const fromAdjusted = new Date(
      from.getFullYear(),
      from.getMonth(),
      1
    );

    // Set second date to last day of month
    const toAdjusted = new Date(
      to.getFullYear(),
      to.getMonth() + 1,
      0   // day 0 = last day of previous month
    );

    return {
      from: formatLocalISO(fromAdjusted),
      to: formatLocalISO(toAdjusted)
    };
  }
  const formatLocalISO = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");

    return `${y}-${m}-${d}`;
  }

  const changeSummaryTab = (event, newValue) => {
    if (duration === "custom" && (!customFromDate || !customToDate)) {
      props.setErrorMessage(t("SELECT_DATE_RANGE"), false);
      return;
    }
    setSummaryTab(newValue);
    // fetchSummaryData();
  };

  const [scrollPosition, setScrollPosition] = useState(0);
  const ScrollTracker = () => {
    useEffect(() => {
      const handleScroll = () => {
        const scrollY = window.scrollY;
        setScrollPosition(scrollY);
      };

      window.addEventListener("scroll", handleScroll);

      // Cleanup
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);

    return null; // This component just tracks scroll
  };

  ScrollTracker();

  if (!dashboardData || !dashboardData.rows) {
    return (
      <div style={{ width: '100%' }} className='newContentWrapper'>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh'
        }}>
          <Loader loading={true} />
        </div>
      </div>
    );
  }

  const onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      setSummaryLoading(true);
      const filteredData = summaryData.filter((row) =>
        Object.values(row).some((val) =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase()),
        ),
      );
      setSummaryData(filteredData);
      setSummaryLoading(false);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((prev) => {
      return !prev;
    });
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleToDateChange = (e) => {
    const newToDate = e.target.value;

    if (customFromDate && newToDate) {
      const from = new Date(customFromDate);
      const to = new Date(newToDate);
      const diffTime = Math.abs(to - from);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (to < from) {
        props.setErrorMessage(t("TO_DATE_CANNOT_BE_BEFORE_FROM_DATE"), false);
        setCustomToDate(today);
        return;
      }
      if (diffDays > 365) {
        // Set toDate to exactly 1 year from fromDate
        const maxToDate = new Date(from);
        maxToDate.setFullYear(maxToDate.getFullYear() + 1);
        setCustomToDate(maxToDate.toISOString().split("T")[0]);
        props.setErrorMessage(t("TO_DATE_MAX_1_YEAR"), false);
      } else {
        setCustomToDate(newToDate);
      }
    } else {
      setCustomToDate(newToDate);
    }
  };

  // helper: convert Date -> ISO YYYY-MM-DD
  const dateToIso = (d) => {
    if (!d || Number.isNaN(d.getTime())) return "";

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };


  // validator for typed strings on blur
  const validateTypedValue = (typedStr) => {
    if (!typedStr) return { ok: true, iso: "" };
    const normalized = typedStr.trim();
    // only accept separators '/' or '-' (MM/DD/YYYY or MM-DD-YYYY)
    const parts = normalized.includes("/")
      ? normalized.split("/")
      : normalized.split("-");
    if (parts.length !== 3)
      return {
        ok: false,
        message: t("INVALID_DATE_FORMAT") || "Invalid format",
      };
    let [mm, dd, yyyy] = parts.map((p) => p.trim());
    if (
      !/^\d{1,2}$/.test(mm) ||
      !/^\d{1,2}$/.test(dd) ||
      !/^\d{2,4}$/.test(yyyy)
    ) {
      return {
        ok: false,
        message: t("INVALID_DATE_FORMAT") || "Invalid format",
      };
    }
    if (yyyy.length === 2) yyyy = "20" + yyyy;
    if (mm.length === 1) mm = "0" + mm;
    if (dd.length === 1) dd = "0" + dd;
    // construct iso
    const iso = `${yyyy}-${mm}-${dd}`;
    const dObj = new Date(iso);
    if (Number.isNaN(dObj.getTime()))
      return { ok: false, message: t("INVALID_DATE") || "Invalid date" };
    // check JS rollover (e.g., 02/30 -> becomes 03/02)
    if (
      dObj.getUTCFullYear() !== Number(yyyy) ||
      dObj.getUTCMonth() + 1 !== Number(mm) ||
      dObj.getUTCDate() !== Number(dd)
    ) {
      return { ok: false, message: t("INVALID_DATE") || "Invalid date" };
    }
    // check not in future
    if (iso > today)
      return {
        ok: false,
        message: t("DATE_CANNOT_BE_FUTURE") || "Date cannot be in future",
      };
    //check earliest date
    if (iso < MIN_DATE_ISO) {
      return {
        ok: false,
        message:
          t("DATE_CANNOT_BE_BEFORE_2024") ||
          "Date cannot be before Jan 1, 2024",
      };
    }
    return { ok: true, iso };
  };

  const handleFromChange = (date) => {

    if (!date) {

      setFromDateSafe("");
      return;
    }

    const iso = dateToLocalISO(date);

    setFromDateSafe(iso);
  };

  const handleFromBlur = (e) => {
    const typed = e?.target?.value?.trim();
    if (!typed) {
      setFromError("");
      return;
    }
    const res = validateTypedValue(typed);
    if (!res.ok) {
      setFromError(res.message);
      return;
    }
    setFromError("");
    setCustomFromDate(res.iso);
    setCustomToDate("");
  };

  const handleToChange = (date) => {

    if (!date) {

      setToDateSafe("");
      return;
    }

    const iso = dateToLocalISO(date);

    setToDateSafe(iso);
  };



  const handleToBlur = (e) => {
    const typed = e?.target?.value?.trim();
    if (!typed) {
      setToError("");
      return;
    }
    const res = validateTypedValue(typed);
    if (!res.ok) {
      setToError(res.message);
      handleToDateChange({ target: { value: "" } });
      return;
    }
    handleToDateChange({ target: { value: res.iso } });
    setToError("");
  };

  // compute max for toDate (from + 1 year or today)
  const computeToMaxDate = () => {

    if (!customFromDate) return new Date();

    const from = parseLocalDate(customFromDate);

    const max = new Date(from);
    max.setFullYear(max.getFullYear() + 1);

    const today = new Date();

    return max > today ? today : max;
  };


  const MUI_DEFAULT_BLUE = "#3f51b5"; //default blue color for MUI
  const datePickerTheme = createTheme({
    palette: {
      primary: {
        main: props.tenantData.color,
      },
    },

    components: {

      // Fix DatePicker TextField root
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-root": {
              height: "32px",
              minHeight: "32px",
              boxSizing: "border-box",
            },
          },
        },
      },

      // Fix OutlinedInput container
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            height: "32px",
            minHeight: "32px",
            boxSizing: "border-box",
          },
          input: {
            height: "32px",
            padding: "0 8px",
            boxSizing: "border-box",
            display: "flex",
            alignItems: "center",
          },
        },
      },

      // Fix icon alignment
      MuiIconButton: {
        styleOverrides: {
          root: {
            padding: "4px",
          },
        },
      },

      // Fix label focus color
      MuiInputLabel: {
        styleOverrides: {
          root: {
            "&.Mui-focused": {
              color: MUI_DEFAULT_BLUE,
            },
          },
        },
      },

      MuiFormLabel: {
        styleOverrides: {
          root: {
            "&.Mui-focused": {
              color: MUI_DEFAULT_BLUE,
            },
          },
        },
      },

    },
  });


  // custom filters code



  const months = [
    { value: 1, label: "Jan" },
    { value: 2, label: "Feb" },
    { value: 3, label: "Mar" },
    { value: 4, label: "Apr" },
    { value: 5, label: "May" },
    { value: 6, label: "Jun" },
    { value: 7, label: "Jul" },
    { value: 8, label: "Aug" },
    { value: 9, label: "Sep" },
    { value: 10, label: "Oct" },
    { value: 11, label: "Nov" },
    { value: 12, label: "Dec" },
  ];

  const currentYear = new Date().getFullYear();
  const startYear = 2024;
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  );


  const convertMonthYearToISO = (month, year, isEnd = false) => {

    if (!month || !year) return "";

    const date = isEnd
      ? new Date(year, month, 0)
      : new Date(year, month - 1, 1);

    return dateToLocalISO(date);
  };

  // ================= VALIDATE DATE RANGE =================
  const validateDateRange = (fromDate, toDate) => {
    if (!fromDate || !toDate) return true;

    const from = parseLocalDate(fromDate);
    const to = parseLocalDate(toDate);

    if (to < from) {

      props.setErrorMessage(
        t("TO_DATE_CANNOT_BE_BEFORE_FROM_DATE"),
        false
      );

      return false;
    }

    return true;
  };

  const parseLocalDate = (dateString) => {

    if (!dateString) return null;

    const [y, m, d] = dateString.split("-").map(Number);

    return new Date(y, m - 1, d);
  };

  // Convert Date object → "YYYY-MM-DD" in LOCAL timezone (safe)
  const dateToLocalISO = (date) => {

    if (!date) return "";

    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");

    return `${y}-${m}-${d}`;
  };


  const isValidOneYearRange = (fromDate, toDate) => {

    if (!fromDate || !toDate) return true;

    const from = parseLocalDate(fromDate);
    const to = parseLocalDate(toDate);

    const max = new Date(from);
    max.setFullYear(max.getFullYear() + 1);

    if (to > max) {

      props.setErrorMessage(
        t("TO_DATE_MAX_1_YEAR"),
        false
      );

      return false;
    }

    return true;
  };

  const setFromDateSafe = (iso) => {

    setCustomFromDate(iso);

    if (!iso) {

      setCustomToDate("");
      setFromMonth("");
      setFromYear("");
      return;
    }

    const d = parseLocalDate(iso);

    setFromMonth(d.getMonth() + 1);
    setFromYear(d.getFullYear());

    if (customToDate) {

      if (
        !validateDateRange(iso, customToDate) ||
        !isValidOneYearRange(iso, customToDate)
      ) {

        setCustomToDate("");
        setToMonth("");
        setToYear("");
      }
    }
  };

  const setToDateSafe = (iso) => {

    if (!iso) {

      setCustomToDate("");
      return;
    }

    const from = parseLocalDate(customFromDate);
    const to = parseLocalDate(iso);

    if (to < from) {

      props.setErrorMessage(
        t("TO_DATE_CANNOT_BE_BEFORE_FROM_DATE"),
        false
      );

      return;
    }

    const maxAllowed = new Date(from);
    maxAllowed.setFullYear(maxAllowed.getFullYear() + 1);

    if (to > maxAllowed) {

      props.setErrorMessage(
        t("TO_DATE_MAX_1_YEAR"),
        false
      );

      return;
    }

    setCustomToDate(iso);
  };

  const handleSearchClick = () => {

    // must exist
    if (!customFromDate || !customToDate) {

      props.setErrorMessage(
        t("SELECT_DATE_RANGE") || "Please select date range",
        false
      );

      return;
    }

    const from = parseLocalDate(customFromDate);
    const to = parseLocalDate(customToDate);

    // To < From validation
    if (to < from) {

      props.setErrorMessage(
        t("TO_DATE_CANNOT_BE_BEFORE_FROM_DATE"),
        false
      );

      return;
    }

    // 1 year validation
    const maxAllowed = new Date(from);
    maxAllowed.setFullYear(maxAllowed.getFullYear() + 1);

    if (to > maxAllowed) {

      props.setErrorMessage(
        t("TO_DATE_MAX_1_YEAR") ||
        "Date range cannot exceed 1 year",
        false
      );

      return;
    }

    // valid
    fetchData();
    fetchSummaryData();
  };

  const validateDateRangeOnSearch = () => {

    if (!customFromDate || !customToDate) {

      props.setErrorMessage(
        t("SELECT_DATE_RANGE") || "Please select date range",
        false
      );

      return false;
    }

    const from = parseLocalDate(customFromDate);
    const to = parseLocalDate(customToDate);

    if (!from || !to) {

      props.setErrorMessage(
        t("SELECT_DATE_RANGE") || "Please select date range",
        false
      );

      return false;
    }

    // To date before From date
    if (to.getTime() < from.getTime()) {

      props.setErrorMessage(
        t("TO_DATE_CANNOT_BE_BEFORE_FROM_DATE") ||
        "To date cannot be before From date",
        false
      );

      return false;
    }

    // 1 year validation
    const maxAllowed = new Date(from);
    maxAllowed.setFullYear(maxAllowed.getFullYear() + 1);
    console.log('check 1111', to, to.getTime(), maxAllowed, maxAllowed.getTime())
    if (to.getTime() > maxAllowed.getTime()) {

      props.setErrorMessage(
        t("TO_DATE_MAX_1_YEAR") ||
        "Date range cannot exceed 1 year",
        false
      );

      return false;
    }

    return true;
  };

  return (
    // <div style={{ width: "100%" }} className="newContentWrapper">

    <div className={"newContentWrapper"}>
      <div className={"breadcrumbWrapper"}>
        <div className={"breadcrumbContent"}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 4, md: 4 }}>
              <Breadcrumb list={bread} />
            </Grid>
            <Grid
              size={{ xs: showSelectOpCo ? 12 : 8, md: 8 }}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: ".5rem",
                }}
              >
                {showSelectOpCo && (
                  <FormControl
                    variant="outlined"
                    size={"small"}
                    className={classes.customeSelectLabel}
                    style={{ minWidth: "150px" }}
                  >
                    <InputLabel id={"opCoLabel"} htmlFor="opCo" shrink>
                      {t("SELECT_OPCO")}
                    </InputLabel>
                    <Select
                      native
                      value={opCo}
                      onChange={handleOpCoChange}
                      size={"small"}
                      labelId={"opCoLabel"}
                      label={t("SELECT_OPCO")}
                      inputProps={{
                        id: "opCo",
                        name: "opCo",
                      }}
                    >
                      <option value="ALL">{t("ALL")}</option>
                      {opCoList.map((opCo) => (
                        <option key={opCo.tenantId} value={opCo.tenantId}>
                          {opCo.tenantName}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                )}
                <Button
                  className={`buttonSecondary ${classes.customiseDropdown}`}
                  aria-describedby={id}
                  type="button"
                  onClick={handleClick}
                >
                  <span style={{ fontSize: "14px", textWrap: "nowrap" }}>
                    {isMobile ? t("VIEW") : t("VIEW_PREFERENCES")}
                  </span>
                  <span
                    style={{
                      marginLeft: ".25rem",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <DownIcon />
                  </span>
                </Button>
                <Popper
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  placement="bottom-start"
                  style={{ zIndex: 9 }}
                >
                  <ClickAwayListener onClickAway={handleClose}>
                    <Paper>
                      <MenuList autoFocusItem={open} id="menu-list-grow">
                        <MenuItem>
                          <FormControlLabel
                            style={{ marginLeft: "2px" }}
                            control={
                              <Checkbox
                                checked={showCount}
                                onChange={(event) =>
                                  setShowCount(event.target.checked)
                                }
                                name={"showCount"}
                                color="primary"
                              />
                            }
                            label={t("SHOW_COUNTS")}
                          />
                        </MenuItem>
                        <MenuItem>
                          <FormControlLabel
                            style={{ marginLeft: "2px" }}
                            control={
                              <Checkbox
                                checked={showGraphs}
                                onChange={(event) =>
                                  setShowGraphs(event.target.checked)
                                }
                                name={"showGraphs"}
                                color="primary"
                              />
                            }
                            label={t("SHOW_GRAPHS")}
                          />
                        </MenuItem>
                        {(isGroupPM ||
                          isPartnerAdmin ||
                          isSalesManager ||
                          isFinanceManager) && (
                            <MenuItem>
                              <FormControlLabel
                                style={{ marginLeft: "2px" }}
                                control={
                                  <Checkbox
                                    checked={showSummary}
                                    onChange={(event) =>
                                      setShowSummary(event.target.checked)
                                    }
                                    name={"showSummary"}
                                    color="primary"
                                  />
                                }
                                label={t("SHOW_SUMMARY")}
                              />
                            </MenuItem>
                          )}
                      </MenuList>
                    </Paper>
                  </ClickAwayListener>
                </Popper>
                <Button
                  onClick={resetFilters}
                  className={`buttonSecondary ${classes.customiseDropdown}`}
                  style={{ textWrap: "nowrap", fontSize: "14px" }}
                >
                  {t("RESET_FILTERS")}
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      <main
        style={{
          position: "relative",
          marginBottom: "0px",
          minHeight: "100vh",
        }}
      >
        {/* <h2>Dashboard</h2>  */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          {/* <DashboardHeader /> */}
          <div
            style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
          >
            <div className={classes.buttonsRowStyle}>
              {[
                // { label: 'Today', value: 'day' },
                // { label: t("WEEK"), value: "week" },
                { label: t("MONTH"), value: "month" },
                { label: t("THREE_MONTHS"), value: "quarterly" },
                { label: isMobile ? t("YTD") : t("YEAR_TO_DATE"), value: "year" },
                { label: t('CUSTOM'), value: 'custom' },
              ].map((option) => (
                <Button
                  disableBaseClass
                  key={option.value}
                  onClick={() => {
                    setDuration(option.value);
                    // setCustomFromDate("");
                    // setCustomToDate("");
                    // setFromMonth("");
                    // setFromYear("");
                    // setToMonth("");
                    // setToYear("");
                  }}
                  className={`${'dashboardFilterButtons'} ${duration === option.value ? 'selectedFilterButtons' : 'filterButtons'}`}
                >
                  {option.label}
                </Button>
              ))}
            </div>
            {duration === "custom" && (
              <div className={classes.dateRowStyle}>

                {/* Toggle View Button */}
                <Tooltip title={dateViewMode === "calendar"
                  ? "Switch to Month/Year view"
                  : "Switch to Calendar view"}>
                  <IconButton
                    className="iconButtonSecondary"
                    style={{ height: '32px', width: '32px' }}
                    onClick={() =>
                      setDateViewMode(prev =>
                        prev === "calendar" ? "monthYear" : "calendar"
                      )
                    }
                  >
                    {dateViewMode === "calendar"
                      ? <ViewModuleIcon />
                      : <CalendarMonthIcon />}
                  </IconButton>
                </Tooltip>


                <LocalizationProvider dateAdapter={AdapterDateFns}>

                  {/* ================= CALENDAR VIEW ================= */}
                  {dateViewMode === "calendar" && (
                    <>
                      {/* FROM DATE */}
                      <ThemeProvider theme={datePickerTheme}>
                        <DatePicker
                          label={t("FROM_DATE")}
                          format="MM/dd/yyyy"
                          disableFuture
                          minDate={MIN_DATE}
                          value={customFromDate ? parseLocalDate(customFromDate) : null}
                          className="override_datepicker_height"
                          onChange={(date) => {

                            if (!date) {
                              setCustomFromDate("");
                              setFromMonth("");
                              setFromYear("");
                              return;
                            }

                            const iso = dateToLocalISO(date);

                            setCustomFromDate(iso);

                            const d = parseLocalDate(iso);

                            setFromMonth(d.getMonth() + 1);
                            setFromYear(d.getFullYear());

                            // reset TO date
                            // setCustomToDate("");
                            // setToMonth("");
                            // setToYear("");
                          }}
                          slotProps={{
                            textField: {
                              placeholder: "MM/DD/YYYY",
                              helperText: fromError || "",
                              error: !!fromError,
                              size: "small",
                              variant: "outlined",
                              sx: { width: "160px" },
                              InputLabelProps: { shrink: true }
                            }
                          }}
                        />
                      </ThemeProvider>


                      {/* TO DATE */}
                      <ThemeProvider theme={datePickerTheme}>
                        <DatePicker
                          label={t("TO_DATE")}
                          format="MM/dd/yyyy"
                          minDate={customFromDate
                            ? parseLocalDate(customFromDate)
                            : MIN_DATE}
                          maxDate={computeToMaxDate()}
                          value={customToDate ? parseLocalDate(customToDate) : null}
                          className="override_datepicker_height"
                          onChange={(date) => {

                            if (!date) {
                              setCustomToDate("");
                              setToMonth("");
                              setToYear("");
                              return;
                            }

                            const iso = dateToLocalISO(date);

                            const from = parseLocalDate(customFromDate);
                            const to = parseLocalDate(iso);

                            if (to < from) {

                              props.setErrorMessage(
                                t("TO_DATE_CANNOT_BE_BEFORE_FROM_DATE"),
                                false
                              );

                              return;
                            }

                            const max = new Date(from);
                            max.setFullYear(max.getFullYear() + 1);

                            if (to > max) {

                              props.setErrorMessage(
                                t("TO_DATE_MAX_1_YEAR"),
                                false
                              );

                              return;
                            }

                            setCustomToDate(iso);

                            const d = parseLocalDate(iso);

                            setToMonth(d.getMonth() + 1);
                            setToYear(d.getFullYear());
                          }}
                          slotProps={{
                            textField: {
                              placeholder: "MM/DD/YYYY",
                              helperText: toError || "",
                              error: !!toError,
                              size: "small",
                              variant: "outlined",
                              sx: { width: "160px" },
                              InputLabelProps: { shrink: true }
                            }
                          }}
                        />
                      </ThemeProvider>

                    </>
                  )}


                  {/* ================= MONTH/YEAR VIEW ================= */}
                  {dateViewMode === "monthYear" && (
                    <Box display="flex" gap={1} alignItems="center">

                      {/* FROM MONTH */}
                      <FormControl size="small" style={{ height: '32px' }}>
                        <InputLabel>From Month</InputLabel>
                        <Select
                          value={fromMonth}
                          label="From Month"
                          sx={{ width: "130px", }}
                          onChange={(e) => {

                            const month = e.target.value;

                            setFromMonth(month);

                            const iso = convertMonthYearToISO(
                              month,
                              fromYear,
                              false
                            );

                            if (!iso) return;

                            setCustomFromDate(iso);

                            // setCustomToDate("");
                            // setToMonth("");
                            // setToYear("");
                          }}
                          style={{ height: '32px' }}
                        >
                          {months.map(m =>
                            <MenuItem key={m.value} value={m.value}>
                              {m.label}
                            </MenuItem>
                          )}
                        </Select>
                      </FormControl>


                      {/* FROM YEAR */}
                      <FormControl size="small" style={{ height: '32px' }}>
                        <InputLabel>From Year</InputLabel>
                        <Select
                          value={fromYear}
                          label="From Year"
                          sx={{ width: "110px" }}
                          onChange={(e) => {

                            const year = e.target.value;

                            setFromYear(year);

                            const iso = convertMonthYearToISO(
                              fromMonth,
                              year,
                              false
                            );

                            if (!iso) return;

                            setCustomFromDate(iso);

                            // setCustomToDate("");
                            // setToMonth("");
                            // setToYear("");
                          }}
                          style={{ height: '32px' }}
                        >
                          {years.map(y =>
                            <MenuItem key={y} value={y}>{y}</MenuItem>
                          )}
                        </Select>
                      </FormControl>


                      {/* TO MONTH */}
                      <FormControl size="small" style={{ height: '32px' }}>
                        <InputLabel>To Month</InputLabel>
                        <Select
                          value={toMonth}
                          label="To Month"
                          sx={{ width: "130px" }}
                          onChange={(e) => {

                            const month = e.target.value;

                            setToMonth(month);

                            const iso = convertMonthYearToISO(
                              month,
                              toYear,
                              true
                            );

                            if (!iso) return;

                            setCustomToDate(iso);
                          }}
                          style={{ height: '32px' }}
                        >
                          {months.map(m =>
                            <MenuItem key={m.value} value={m.value}>
                              {m.label}
                            </MenuItem>
                          )}
                        </Select>
                      </FormControl>


                      {/* TO YEAR */}
                      <FormControl size="small" style={{ height: '32px' }}>
                        <InputLabel>To Year</InputLabel>
                        <Select
                          value={toYear}
                          label="To Year"
                          sx={{ width: "110px" }}
                          onChange={(e) => {

                            const year = e.target.value;

                            setToYear(year);

                            const iso = convertMonthYearToISO(
                              toMonth,
                              year,
                              true
                            );

                            if (!iso) return;

                            setCustomToDate(iso);
                          }}
                          style={{ height: '32px' }}
                        >
                          {years.map(y =>
                            <MenuItem key={y} value={y}>{y}</MenuItem>
                          )}
                        </Select>
                      </FormControl>

                    </Box>
                  )}

                </LocalizationProvider>



                {/* SEARCH BUTTON */}
                <Tooltip title={t("SEARCH")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={() => {

                      if (!customFromDate || !customToDate) {

                        props.setErrorMessage(
                          t("SELECT_DATE_RANGE"),
                          false
                        );

                        return;
                      }

                      const from = parseLocalDate(customFromDate);
                      const to = parseLocalDate(customToDate);

                      if (to < from) {

                        props.setErrorMessage(
                          t("TO_DATE_CANNOT_BE_BEFORE_FROM_DATE"),
                          false
                        );

                        return;
                      }

                      const max = new Date(from);
                      max.setFullYear(max.getFullYear() + 1);

                      if (to > max) {

                        props.setErrorMessage(
                          t("TO_DATE_MAX_1_YEAR"),
                          false
                        );

                        return;
                      }

                      fetchData();
                      fetchSummaryData();
                    }}
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>



                {/* CLEAR BUTTON */}
                <Tooltip title={t("CLEAR")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={() => {

                      setCustomFromDate("");
                      setCustomToDate("");

                      setFromMonth("");
                      setFromYear("");

                      setToMonth("");
                      setToYear("");
                    }}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>


              </div>
            )}

            {/* {customFromDate && customToDate &&
                new Date(customToDate) < new Date(customFromDate) && (
                  <div style={{
                    color: "red",
                    fontSize: "12px",
                    marginLeft: "8px"
                  }}>
                    {t("TO_DATE_CANNOT_BE_BEFORE_FROM_DATE")}
                  </div>
                )} */}

            {duration === "custom1111" && (
              <div className={classes.dateRowStyle}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  {/* FROM date */}
                  <ThemeProvider theme={datePickerTheme}>
                    <DatePicker
                      label={t("FROM_DATE")}
                      format="MM/dd/yyyy"
                      disableFuture
                      minDate={MIN_DATE}
                      value={customFromDate ? new Date(customFromDate) : null}
                      onChange={handleFromChange}
                      onError={(reason) => {
                        // optional error handling
                        console.warn("From date error:", reason);
                      }}
                      slotProps={{
                        textField: {
                          onBlur: handleFromBlur,
                          placeholder: "MM/DD/YYYY",
                          helperText: fromError || "",
                          error: !!fromError,
                          size: "small",
                          variant: "outlined",
                          fullWidth: false,
                          sx: { width: "160px" },
                          InputLabelProps: { shrink: true },
                          InputProps: {
                            classes: { input: "date-input-small-placeholder" },
                          },
                        },
                      }}
                    />
                  </ThemeProvider>

                  {/* TO date */}
                  <ThemeProvider theme={datePickerTheme}>
                    <DatePicker
                      label={t("TO_DATE")}
                      format="MM/dd/yyyy"
                      minDate={
                        customFromDate ? new Date(customFromDate) : MIN_DATE
                      }
                      maxDate={computeToMaxDate()}
                      value={customToDate ? new Date(customToDate) : null}
                      onChange={handleToChange}
                      slotProps={{
                        textField: {
                          onBlur: handleToBlur,
                          placeholder: "MM/DD/YYYY",
                          helperText: toError || "",
                          error: !!toError,
                          size: "small",
                          variant: "outlined",
                          fullWidth: false,
                          sx: { width: "160px" },
                          InputLabelProps: { shrink: true },
                          InputProps: {
                            classes: { input: "date-input-small-placeholder" },
                          },
                        },
                      }}
                    />
                  </ThemeProvider>
                </LocalizationProvider>
                <Tooltip title={t("SEARCH")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={() => {
                      if (
                        duration === "custom" &&
                        (!customFromDate || !customToDate)
                      ) {
                        props.setErrorMessage(t("SELECT_DATE_RANGE"), false);
                        return;
                      }
                      fetchData();
                      fetchSummaryData();
                    }}
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title={t("CLEAR")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={() => {
                      setCustomToDate("");
                      setCustomFromDate("");
                    }}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              </div>
            )}
          </div>
          <Tooltip title={t('REPORTING_PERIOD')}>
            <div style={{ backgroundColor: props.tenantData.color, color: '#fff', padding: '3px 5px 4px 3px', borderRadius: '8px' }}>
              <CalendarMonthIcon style={{ width: '25px', height: '25px', float: 'left', marginRight: '5px' }} />
              <span style={{ float: 'left' }}>
                {/* <span style={{ fontSize: '12px' }}>{t('REPORTING_PERIOD')}</span>
                          <br /> */}
                {/* {duration === 'week' ? `${moment().subtract(1, 'weeks').format('MMM Do, YYYY')} - ${moment().format('MMM Do, YYYY')} (${t('WEEK')})`  : ''} */}

                {/* if ((props.providerType === "SOLUTION_PROVIDER" || props.tenantRoles.includes("MASTER_PROVIDER")) && opCo === 'ALL') { */}
                {(props.providerType === "SOLUTION_PROVIDER" || props.tenantRoles.includes("MASTER_PROVIDER")) && opCo === 'ALL'
                  ?
                  <>
                    {duration === 'month' ? `${moment().subtract(1, 'months').format('MMM Do, YYYY')} - ${moment().format('MMM Do, YYYY')} (${t('MONTH')})` : ''}
                    {duration === 'quarterly' ? `${moment().subtract(1, 'quarters').format('MMM Do, YYYY')} - ${moment().format('MMM Do, YYYY')} (${t('THREE_MONTHS')})` : ''}
                    {duration === 'year' ? `${moment().startOf('year').format('MMM Do, YYYY')} - ${moment().format('MMM Do, YYYY')} (${t('YEAR_TO_DATE')})` : ''}
                  </>
                  :
                  <>
                    {duration === 'month' ? `${cycleStart.clone().subtract(1, 'month').format('MMM Do, YYYY')} - ${cycleStart.clone().subtract(1, 'day').format('MMM Do, YYYY')} (${t('MONTH')})` : ''}
                    {duration === 'quarterly' ? `${cycleStart.clone().subtract(3, 'months').format('MMM Do, YYYY')} - ${cycleStart.clone().subtract(1, 'day').format('MMM Do, YYYY')} (${t('THREE_MONTHS')})` : ''}
                    {duration === 'year' ? `${yearStart.format('MMM Do, YYYY')} - ${lastBillDate.format('MMM Do, YYYY')} (${t('YEAR_TO_DATE')})` : ''}
                  </>
                }

                {/* {duration === 'custom' ? ` ${customFromDate ? moment(customFromDate).format('MMM Do, YYYY') :'-'} - ${customToDate ? moment(customToDate).format('MMM Do, YYYY') :'-'} (${t('CUSTOM')})`  : ''} */}
                {duration === 'custom' ? ` ${customFromDate ? formatDate(customFromDate, false) : '-'} - ${customToDate ? formatDate(customToDate, false) : '-'} (${t('CUSTOM')})` : ''}
              </span>
              <span style={{ clear: 'both' }}></span>
            </div>
          </Tooltip>
        </div>
        {/* <Grid container spacing={2}> */}
        {dashboardData &&
          dashboardData.rows &&
          dashboardData.rows.map((row, rowIndex) => (
            <Grid
              container
              spacing={2}
              key={rowIndex}
              style={{ marginBottom: "1rem", marginTop: '1rem' }}
            >
              {row.columns.map((column, colIndex) => {

                const gridSize = column.widthInPercentage
                  ? Math.round((column.widthInPercentage / 100) * 12)
                  : 12;
                return (
                  <Grid
                    size={{ xs: 12, md: gridSize, lg: gridSize }}
                    key={`${rowIndex}-${colIndex}`}>
                    {/* {column.portlets.map((portlet, portletIndex) =>
                            portlet.name && (
                              <div key={`${rowIndex}-${colIndex}-${portletIndex}`}>
                                {portlet.type === 'count' ? (
                                  showCount && (
                                    <RenderCountPortlet
                                      key={portlet.id}
                                      portlet={portlet}
                                      duration={duration}
                                      customFromDate={customFromDate}
                                      customToDate={customToDate}
                                      fetchPortletData={fetchPortletData}
                                      portletData={portletData[portlet.id]}
                                    />
                                  )
                                ) : (
                                  showGraphs && (
                                    <RenderGraphPortlet
                                      key={portlet.id}
                                      portlet={portlet}
                                      duration={duration}
                                      customFromDate={customFromDate}
                                      customToDate={customToDate}
                                      fetchPortletData={fetchPortletData}
                                      portletData={portletData[portlet.id]}
                                    />
                                  )
                                )}
                              </div>
                            )
                          )} */}
                    {column.portlets.map((portlet, portletIndex) => {
                      const isLoading = !!portletLoading[portlet.id];
                      const data = portletData[portlet.id];
                      const shouldRender =
                        (portlet.type === "count" && showCount) ||
                        (portlet.type !== "count" && showGraphs);

                      return (
                        portlet.name && (
                          <div
                            key={`${rowIndex}-${colIndex}-${portletIndex}`}
                            style={{
                              position: "relative",
                              minHeight: "151px",
                              // padding: "0.5rem",
                              overflow: "hidden",
                              borderRadius: "8px",
                              marginTop: '1rem',
                              border: isLoading ? '1px solid lightgray' : 'none'
                              // opacity: '0.5'
                            }}
                          >
                            {/* Single, contained loader overlay */}
                            {isLoading && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  background: "rgba(255,255,255,0.55)",
                                  // backdropFilter: "blur(3px)",
                                  // zIndex: 3,
                                  transition: "opacity 0.3s ease-in-out",
                                  borderRadius: "inherit",
                                  pointerEvents: "none",
                                }}
                              >
                                <div >
                                  <Skeleton height={18} width={240} />
                                  <Skeleton height={12} width={280} count={2} style={{ marginTop: 8 }} />
                                  {/* <Loader loading={true} /> */}
                                  {/* <SimpleLoader
                                        size={40}
                                        color="#9747ff"
                                        label="Loading data..."
                                        showLabel={true}
                                      /> */}
                                </div>
                              </div>
                            )}

                            {/* Render actual portlet content only when not loading */}
                            {shouldRender && !isLoading && (
                              <>
                                {portlet.type === "count" ? (
                                  <RenderCountPortlet
                                    portlet={portlet}
                                    duration={duration}
                                    customFromDate={customFromDate}
                                    customToDate={customToDate}
                                    fetchPortletData={fetchPortletData}
                                    portletData={data}
                                  />
                                ) : (
                                  <RenderGraphPortlet
                                    portlet={portlet}
                                    duration={duration}
                                    customFromDate={customFromDate}
                                    customToDate={customToDate}
                                    fetchPortletData={fetchPortletData}
                                    portletData={data}
                                  />
                                )}
                              </>
                            )}
                          </div>
                        )
                      );
                    })}
                  </Grid>
                )
              })}
            </Grid>
          ))}
        {/* </Grid> */}
        {(isGroupPM ||
          isPartnerAdmin ||
          isSalesManager ||
          isFinanceManager) &&
          showSummary && (
            <Grid container spacing={2} style={{ marginTop: "1rem" }}>
              <Grid size={{ xs: 12 }}>
                <div>
                  <h2 style={{ marginBottom: "0" }}>{t("SUMMARY")}</h2>
                </div>
              </Grid>
              {(summaryTabs.length > 0 ||
                (summaryData && summaryData.length > 0)) && (
                  <Grid
                    size={{ xs: 12 }}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      {summaryTabs.length > 0 && (
                        <Tabs
                          indicatorColor="primary"
                          onChange={changeSummaryTab}
                          value={summaryTab}
                          style={{ padding: "0" }}
                          className={classes.createPackageComponentTabs}
                        >
                          {summaryTabs.map((tab) => (
                            <Tab
                              key={tab.value}
                              value={tab.value}
                              label={tab.label}
                            />
                          ))}
                        </Tabs>
                      )}
                      {summaryTabs.length === 0 && isPartnerAdmin && (
                        <span className={classes.graph_description}>
                          {summaryData.length === 1
                            ? `${summaryData.length} ${t("OPCO")}`
                            : `${summaryData.length} ${t("OPCO")}s`}
                        </span>
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      {summaryData && summaryData.length > 0 && (
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: ".5rem",
                          }}
                        >
                          <Input
                            size={"small"}
                            variant={"outlined"}
                            placeholder={t("SEARCH")}
                            value={searchTerm}
                            name={"search"}
                            onChange={(e) => {
                              setSearchTerm(e.target.value);
                            }}
                            divClass={classes.inputClass}
                            onKeyDown={(e) => {
                              onSearchKeyDown(e);
                            }}
                          />
                          <Tooltip title={t("SEARCH")}>
                            <IconButton
                              className="iconButtonSecondary"
                              onClick={(e) => {
                                onSearchKeyDown(e);
                              }}
                            >
                              <SearchIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={t("CLEAR")}>
                            <IconButton
                              className="iconButtonSecondary"
                              onClick={() => {
                                setSearchTerm("");
                                setSummaryData(summaryDataProxy);
                              }}
                            >
                              <ClearIcon />
                            </IconButton>
                          </Tooltip>
                        </span>
                      )}
                    </div>
                  </Grid>
                )}
              <Grid size={{ xs: 12 }}>
                {summaryLoading ? (
                  // <Loader loading={summaryLoading} />
                  <div className='roundCorners borderOutline' style={{ background: 'white', padding: 'inherit', minHeight: '2rem', padding: '2rem' }}>
                    <Skeleton height={18} width={440} style={{ marginBottom: '1rem', marginTop: '1.5rem' }} />
                    <Skeleton height={12} width={680} count={3} />
                  </div>
                ) : (
                  <div
                    className="roundCorners borderOutline"
                    style={{
                      background: "white",
                      padding:
                        summaryData && summaryData.length > 0
                          ? "0"
                          : "inherit",
                      minHeight: "2rem",
                    }}
                  >
                    <GenericTable
                      data={summaryData}
                    />
                  </div>
                )}
              </Grid>
            </Grid>
          )}
        {/* <Grid container spacing={2} style={{ marginTop: '1rem' }}>
            <Grid item xs={12}>
              <div className={'roundCorners borderOutline'} style={{ marginTop: '1rem', background: 'white' }}>
                <div>
                  <h3 className={classes.graph_name}>Reports</h3>
                </div>
                <Tabs
                  // indicatorColor="primary"
                  onChange={handleTabChange}
                  // textColor="primary"
                  value={currentTab}
                  variant="scrollable"
                  className={'createPackageTabs dashboardGenericTabs'}
                >
                  {genericReportsList && genericReportsList.map((report, index) => (
                    <Tab value={index} key={index} label={report.description} />
                  ))}
                </Tabs>
                <div>
                  {renderGenericReports &&
                    <GenericReports location={genericReportParams} match={reportId} screen='dashboard' scrollPosition={scrollPosition} />
                  }
                </div>
              </div>
            </Grid>
          </Grid> */}
      </main>
    </div>

    // </div>
  );
};

const mapStateToProps = (state) => {
  return {
    genericReports: state.auth.genericReports,
    loggedInUserType: state.auth.userLoginType,
    tenantData: state.auth.tenantData,
    tenantRoles: state.auth.tenantRoles,
    securityGroupsList: state.auth.securityGroupsList,
    loggedInUserType: state.auth.userLoginType,
    providerType: state.auth.providerType,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(DashboardReports));
